// extracted by mini-css-extract-plugin
export var button = "styles-module__button___QnHhD";
export var form = "styles-module__form___hpvNC";
export var input = "styles-module__input___Kdy1s";